package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

/**
 * A network's service area, kept so a cold start offline can still dim the map correctly.
 *
 * Its own types rather than the domain's: the domain stays free of serialization, and the
 * shape of a service area is the part most likely to change as this is tuned.
 */
@Serializable
internal data class CachedCoverage(
    val bounds: CachedBox,
    val points: List<CachedPoint>,
)
